module.exports = __webpack_public_path__ + "static/media/PuertoPenasco.a7954d78.jpg";